<ng-container *ngIf="iconType == 'material'">
    <span class="material-symbols-outlined select-none" [class]='iconClass' translate="no">
        {{iconName}}
    </span>
</ng-container>
<ng-container *ngIf="iconType == 'mine'">
    <span class="mgIcon" [class]="iconClass + ' mgIcon-' + iconName" translate="no"></span>
</ng-container>